import { render } from "./Words.vue?vue&type=template&id=2ca6c8f7&scoped=true"
const script = {}

import "./Words.vue?vue&type=style&index=0&id=2ca6c8f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ca6c8f7"

export default script